import { Spacing } from '../../design-system/spacing';
import { styled } from '../../utils/styled';
import { CAROUSEL_HORIZONTAL_PADDING } from './constants';

export const DotsContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isColumns',
})<{ isColumns: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ isColumns }) =>
    isColumns ? 'space-between' : 'center'};
  ${({ isColumns, theme }) =>
    isColumns &&
    `
    gap: ${theme.spacing(Spacing.Medium)};
    max-width: 60%;
    margin: 0 auto;
    padding-top: ${theme.spacing(Spacing.Small)};
  `}
`;

export const SwipeContainer = styled('div')`
  width: 100%;
  overflow: hidden;
`;

export const CarouselWrapper = styled('div', {
  shouldForwardProp: (prop) =>
    prop !== 'bigWidth' && prop !== 'columnNumbers' && prop !== 'isColumns',
})<{
  bigWidth: number;
  columnNumbers: number;
}>`
  width: ${({ bigWidth, columnNumbers }) =>
    ((bigWidth + CAROUSEL_HORIZONTAL_PADDING) * columnNumbers) / 3}px;
  overflow: hidden;
  display: flex;
  flex-wrap: nowrap;
`;

export const ComponentContainer = styled('div')<{
  position: number;
  isHolding: boolean;
}>`
  transform: translateX(-${({ position }) => position}px);
  transition: ${({ isHolding }) =>
    isHolding ? 'none' : 'transform 0.3s ease'};
  width: calc(300% + 96px);
  overflow: hidden;
  display: flex;
  gap: ${({ theme }) => theme.spacing(Spacing.XXLarge)};
`;

export const ComponentWrapper = styled('div', {
  shouldForwardProp: (prop) =>
    prop !== 'position' &&
    prop !== 'isHolding' &&
    prop !== 'bigWidth' &&
    prop !== 'columnNumbers',
})<{
  position: number;
  isHolding: boolean;
  bigWidth: number;
  columnNumbers: number;
}>`
  transform: translateX(-${({ position }) => position}px);
  transition: ${({ isHolding }) =>
    isHolding ? 'none' : 'transform 0.3s ease'};
  display: flex;
  width: ${({ bigWidth, columnNumbers }) =>
    (bigWidth + CAROUSEL_HORIZONTAL_PADDING) * columnNumbers}px;
  flex-wrap: nowrap;
  gap: ${({ theme }) => theme.spacing(Spacing.XXLarge)};
`;

export const NavigationDots = styled('button', {
  shouldForwardProp: (prop) => prop !== 'active',
})<{
  active: boolean;
}>`
  width: ${({ theme }) => theme.spacing(Spacing.Small)};
  height: ${({ theme }) => theme.spacing(Spacing.Small)};
  border: none;
  cursor: pointer;
  margin: ${({ theme }) =>
    `${theme.spacing(Spacing.Small)} ${theme.spacing(Spacing.Small)}`};
  border-radius: ${({ theme }) => theme.borderRadii.circular};
  background-color: ${(props) =>
    props.active
      ? props.theme.palette.primary.main
      : props.theme.palette.primary.light};
`;
